/* The artwork and where it is shown, for whichever Mirror this page is.
   Everything that differs from one Mirror to the next arrives in window.MirrorEra (written by the section):
   its title, its artwork, the inches of its print and the presentation it is first shown in. */
(function(){
  const files=window.VIULET_ASSETS,era=window.MirrorEra||{};
  const abs=path=>new URL(path,document.baseURI).href;
  const resolve=item=>({...item,src:abs(item.src||item.path)});
  const frames=Object.fromEntries(Object.entries(files.frames).map(([name,item])=>[name,resolve(item)]));
  const mats=Object.fromEntries(Object.entries(files.mats).map(([name,item])=>[name,resolve(item)]));
  const details=Object.fromEntries(Object.entries(files.details).map(([name,item])=>[name,resolve(item)]));
  const previewPricing={base:111,framed:111,premiumFinish:111,currency:'USD'};
  const art=era.artwork||{},print=era.print||{};
  const inches=value=>Number(value)>0?Number(value):20;
  const widthIn=inches(print.width),heightIn=inches(print.height);
  // What a frame adds to the print, in inches: 1.5 with Lined and 5 with Crowned, as on Letters (21.5 and 25 for a 20 × 20 print),
  // unless this Mirror's are given for its width and its height.
  const adds=(value,usual)=>value!==undefined&&value!==null&&value!==''&&Number(value)>=0?Number(value):usual;
  const chosen=era.selection||{};
  const pick=(value,allowed,fallback)=>allowed.includes(value)?value:fallback;
  window.VIULET_GALLERY_CONFIG={
    artwork:{
      id:era.handle,title:era.title,artist:era.artist||'Benjamin Viulet',
      src:abs(art.src),width:art.width,height:art.height,
      detail:{src:abs(art.detail||art.src),width:art.detailWidth||art.width,height:art.detailHeight||art.height},
      // The frames are drawn for one nominal size (20 inches). A work that is wider or taller than it is square
      // says so with two factors of that size, its longer side as stated and the other as the picture itself is
      // made, so that the picture is never cut nor stretched to fit the drawing.
      shape:(()=>{const pw=Number(art.width)||1,ph=Number(art.height)||1;if(widthIn===heightIn)return{w:widthIn/20,h:heightIn/20};
        return widthIn>heightIn?{w:widthIn/20,h:widthIn/20*ph/pw}:{w:heightIn/20*pw/ph,h:heightIn/20};})(),
      // The drawing's Crowned mat across the width (mx) and the height (my), when this Mirror's Crowned measurements
      // give them (the frame is 0.75 in a side, the usual mat 1.75 in): The Observer is 25 × 22 on a 22 × 18 print.
      matScale:(()=>{const side=add=>add!==undefined&&add!==null&&add!==''&&Number(add)>=0?Math.max(0,(Number(add)-1.5)/2)/1.75:1;
        return{mx:side(print.mattedW),my:side(print.mattedH)};})(),
      printWidthIn:widthIn,printHeightIn:heightIn,
      addLined:adds(print.lined,1.5),addMatted:adds(print.matted,5),
      addLinedW:adds(print.linedW,undefined),addLinedH:adds(print.linedH,undefined),addMattedW:adds(print.mattedW,undefined),addMattedH:adds(print.mattedH,undefined),
      // (false for a Mirror whose inches the page has not been told: its proportions are drawn, no inches are stated)
      sizeKnown:print.known!==false,
      dimensions:[20],
      defaultSelection:{size:20,
        presentation:pick(chosen.presentation==='Haloed'?'Crowned':chosen.presentation,['Untethered','Lined','Crowned'],'Crowned'),
        finish:pick(chosen.finish,['Seraph White','Nocturne Black','Atelier Wood','Midnight Silver','Midas Gold'],'Nocturne Black'),
        mat:pick(chosen.mat,['White','Cream','Black'],'Cream')}
    },
    assets:{
      frames,mats,
      details,
      backgrounds:{
        gallery:{name:'Gallery',color:'#f1eee6',artCenterY:.48,scaleFieldWidthIn:50,
          lighting:{castOpacity:.68,contactOpacity:.39,castBlur:1.05,castX:.72,castY:1.14,unframedStrength:1.24,unframedLift:1.20,recessStrength:1.8,printShadowStrength:2.1},
          focusLayouts:{20:{fieldWidthIn:30},30:{fieldWidthIn:44},40:{fieldWidthIn:49}}},
        room:{name:'Sunlit room',src:abs(window.ViuletJourneyAsset("assets/room-one-restored.webp")),color:'#f1eee6',artCenterY:.375,
          video:{src:abs(window.ViuletJourneyAsset("assets/sunlight-loop.mp4")),width:1440,height:1440,type:'video/mp4'},
          // Off-camera daylight on the left agrees with this room's down-right cast shadows.
          surfaceReflection:{type:'soft-window',opacity:.085,highlightOpacity:.11,offsetXIn:2},
          sceneFit:'contain',cameraCoupled:true,cameraFieldWidthIn:68,sourceAnchorX:.5,sourceAnchorY:.375,scaleFieldWidthIn:68,focusFieldWidthIn:48,
          lighting:{castOpacity:.56,contactOpacity:.35,castBlur:1.2,castX:.65,castY:1.08,unframedStrength:1.15,unframedLift:1.25,recessStrength:1.7,printShadowStrength:1.95,environmentAmount:.10},
          focusLayouts:{
            20:{fieldWidthIn:48},
            30:{fieldWidthIn:64},
            40:{fieldWidthIn:64}
          }
        }
      }
    },
    initialBackground:'gallery',initialView:'focus',hideMotionControl:true,
    // An edition that is sold out can still be looked at in every presentation; it cannot be claimed.
    soldOut:!!era.soldOut,
    previewPricing,
    /* A stand-in only: mirror-era-shopify.js replaces it with the store's own prices and variants. */
    resolvePrice:async selection=>{
      const framed=selection.presentation==='Lined'||selection.presentation==='Crowned';
      const premium=framed&&['Midas Gold','Midnight Silver'].includes(selection.finish);
      return {amount:previewPricing.base+(framed?previewPricing.framed:0)+(premium?previewPricing.premiumFinish:0),currency:previewPricing.currency,test:true};
    },
    onClaim:null
  };
})();
